import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-popup',
  templateUrl: './privacy-popup.component.html'
})
export class PrivacyPopupComponent {
  constructor() {}
}
